export default __webpack_public_path__ + "static/icon-centralized-management-461cfac02d86a47dc4bac1a46dca3e82.png";